import Router from "@koa/router"
import * as controller from "../../controllers/global/users"
import { feature } from "../../../middleware"
import { Feature } from "@budibase/types"
import { auth } from "@budibase/backend-core"

const router: Router = new Router()

router
  .post(
    "/api/global/users/:userId/app/:appId/builder",
    auth.builderOrAdmin,
    feature.requireFeatures(Feature.APP_BUILDERS),
    controller.addAppBuilder
  )
  .delete(
    "/api/global/users/:userId/app/:appId/builder",
    auth.builderOrAdmin,
    feature.requireFeatures(Feature.APP_BUILDERS),
    controller.removeAppBuilder
  )

export default router
